import {
  REQUEST_DISBURSEMENT,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING,
  DISBURSEMENT_HISTORY,
  CASH_OUT_HISTORY,
  GET_SELLER_CASHOUT_FEE,
  GET_DISBURSEMENT_SETTING
} from '../constants'

import error from '../utils/error';
import { printError } from "../utils";

const initialState = {
  disbursement: {
    data: null,
    status_code: 0,
    message: '',
    isSubmit: false,
    error: null
  },
  balance: {
    isFetch: false,
    dataBalance: [],
    error: null,
    status_code: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  cashout: {
    isFetch: false,
    dataCashOut: [],
    error: null,
    status_code: 0,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  cashoutFee: {
    isFetch: false,
    amount_fee: 0,
    error: null
  },
  disbursementSetting: {
    isFetch: false,
    type: "percentage",
    cashout_fee: 0, //percentage
    admin_fee: 0,
    max_fee: 0,
    error: null
  }
}


const disbursementHistory = (state, {data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    balance: {
      ...state.balance,
      isFetch: false,
      dataBalance: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const cashOutHistory = (state, { data: { data, last_page, current_page, per_page, total }, status_code }) => {
  let newState = {
    ...state,
    cashout: {
      ...state.cashout,
      isFetch: false,
      dataCashOut: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }
  return newState
}

const disbursementReducer = (state = initialState, action) => {
  switch(action.type) {
    case `${REQUEST_DISBURSEMENT}${PROMISE_PENDING}` : 
    return {...state, disbursement: {...state.disbursement, isSubmit:true}}
    case `${REQUEST_DISBURSEMENT}${PROMISE_FULFILLED}` :
    {
      const {status_code, message, data } = action.payload
      return {...state, disbursement: {...state.disbursement, data, status_code, message, isSubmit:false, error:null}}
    }
    case `${REQUEST_DISBURSEMENT}${PROMISE_REJECTED}` :
      return {...state, disbursement: {...state.disbursement, ...error(action.payload), isSubmit:false }}

    //disbursment history
    case `${DISBURSEMENT_HISTORY}${PROMISE_PENDING}`:
      return ({
        ...state, "balance": {...state.balance, isFetch: true}
      });
    case `${DISBURSEMENT_HISTORY}${PROMISE_FULFILLED}`:
      return (disbursementHistory(state, action.payload));
    case `${DISBURSEMENT_HISTORY}${PROMISE_REJECTED}`:
      return ({
        ...state, balance: {...state.balance, isFetch: false, error: {...action.payload.response.data.error}}
      });

    //cashout history
    case `${CASH_OUT_HISTORY}${PROMISE_PENDING}`:
      return ({
        ...state, "cashout": {...state.cashout, isFetch: true}
      })
    case `${CASH_OUT_HISTORY}${PROMISE_FULFILLED}`:
      return (cashOutHistory(state, action.payload))
    case `${CASH_OUT_HISTORY}${PROMISE_REJECTED}`:
      return ({
        ...state, cashout: {...state.cashout, isFetch: false, error: {...action.payload.response.data.error}}
      })

    case `${GET_SELLER_CASHOUT_FEE}${PROMISE_PENDING}`:
      return ({
        ...state,
        cashoutFee: {
          ...state.cashoutFee,
          isFetch: true,
          error: null
        }
      })
    case `${GET_SELLER_CASHOUT_FEE}${PROMISE_FULFILLED}`:
      return ({
        ...state,
        cashoutFee: {
          ...state.cashoutFee,
          isFetch: false,
          amount_fee: action.payload.data.fee,
          error: null
        }
      })
    case `${GET_SELLER_CASHOUT_FEE}${PROMISE_REJECTED}`:
      return ({
        ...state,
        cashoutFee: {
          ...state.cashoutFee,
          isFetch: false,
          error: printError(action.payload.data)
        }
      })

    case `${GET_DISBURSEMENT_SETTING}${PROMISE_PENDING}`:
      return({
        ...state,
        disbursementSetting: {
          ...state.disbursementSetting,
          isFetch: true,
          error: null
        }
      })
    case `${GET_DISBURSEMENT_SETTING}${PROMISE_FULFILLED}`:
      return({
        ...state,
        disbursementSetting: {
          ...state.disbursementSetting,
          isFetch: false,
          error: null,
          type: action.payload.data.type,
          cashout_fee: action.payload.data.cashout_fee,
          admin_fee: action.payload.data.admin_fee,
          max_fee: action.payload.data.max_fee
        }
      })
    case `${GET_DISBURSEMENT_SETTING}${PROMISE_REJECTED}`:
      return({
        ...state,
        disbursementSetting: {
          ...state.disbursementSetting,
          isFetch: false,
          error: action.payload.data
        }
      })
    case "RESET_DISBURSEMENT_SETTING": {
      return({
        ...state,
        disbursementSetting: {
          ...state.disbursementSetting,
          isFetch: false,
          type: "percentage",
          cashout_fee: 0,
          admin_fee: 0,
          max_fee: 0,
          error: null
        },
        cashoutFee: {
          ...state.cashoutFee,
          isFetch: false,
          amount_fee: 0,
          error: null
        }
      })
    }


    default: return state;
  }
}

export default disbursementReducer;
